// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_B-u","cls2":"PodcastLibraryCarouselAd-cls2_uLB PodcastLibraryCarouselAd-cls1_B-u"};